<div class="sc-head d-flex justify-content-between align-items-center">
    <div class="cart-count">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px"
        viewBox="0 0 472.337 472.336" style="enable-background:new 0 0 472.337 472.336;" xml:space="preserve">
        <path d="M406.113,126.627c0-5.554-4.499-10.05-10.053-10.05h-76.377V91.715C319.684,41.143,278.543,0,227.969,0
               c-50.573,0-91.713,41.143-91.713,91.715v24.862H70.45c-5.549,0-10.05,4.497-10.05,10.05L3.914,462.284
               c0,5.554,4.497,10.053,10.055,10.053h444.397c5.554,0,10.057-4.499,10.057-10.053L406.113,126.627z M156.352,91.715
               c0-39.49,32.13-71.614,71.612-71.614c39.49,0,71.618,32.13,71.618,71.614v24.862h-143.23V91.715z M146.402,214.625
               c-9.92,0-17.959-8.044-17.959-17.961c0-7.269,4.34-13.5,10.552-16.325v17.994h14.337v-18.237
               c6.476,2.709,11.031,9.104,11.031,16.568C164.363,206.586,156.319,214.625,146.402,214.625z M310.484,214.625
               c-9.922,0-17.959-8.044-17.959-17.961c0-7.269,4.341-13.495,10.548-16.325v17.994h14.338v-18.241
               c6.478,2.714,11.037,9.108,11.037,16.568C328.448,206.586,320.407,214.625,310.484,214.625z" />
      </svg>
      <span style="color: #59b828;" *ngIf="itemCount>0">{{itemCount}} {{'CART.ITEM' | translate}}</span>
    </div>
    <span onclick="cartclose()" class="close-icon"><i class="fas fa-times"></i></span>
  </div>

  <div class="cart-product-container">
    <div class="cart-product-item" *ngFor="let item of cartList">
      <div class="close-item" (click)="removecart(item)"><i class="fas fa-times"></i></div>
      <div class="row align-items-center p-0">
        <div class="col-6 p-0">
          <div class="thumb pl-3 p-2">
            <a [routerLink]="['/product-detail',item?.productName, item?.productId]">
              <img style="max-width: 95px; max-height: 80px" [src]="item?.productImage" alt="products">
            </a>
          </div>
        </div>
        <div class="col-6">
          <div class="product-content">
            <a class="product-title" [routerLink]="['/product-detail',item?.productName, item?.productId]">
              <span *ngIf="currentLang == 'en'">{{item.productName}}</span>
              <span *ngIf="currentLang == 'hi'">{{item.productNameHin}}</span>
              <span *ngIf="currentLang == 'mr'">{{item.productNameMar}}</span>
               </a>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-6">
          <app-control [productDetails]="item" [fromCart]="true"></app-control>
        </div>
        <div class="col-6">
          <div class="product-price">
            <del>&#8377;{{item.mrp * item.quantity}}</del>
            <span class="ml-4">&#8377;{{item.offerPrice * item.quantity}}</span>
          </div>
        </div>
      </div>
        <!-- <div class="row">
          <div class="col-6"></div>
          <div class="col-6 saveforlater">
            <a (click)="saveForLater(item)">{{'CART.SAVE_FOR_LATER' | translate}}</a>
          </div>
        </div> -->
    </div>

    <div class="no-item" *ngIf="cartList.length==0">
      {{'CART.NO_ITEM_FOUND_IN_YOUR_CART' | translate}}
    </div>

  </div>
  <div class="cart-footer">
    <!-- <div class="product-other-charge1">
      <p class="d-flex justify-content-between">
        <span>Delevery charge</span>
        <span>$8.00</span>
      </p>
      <a href="#">Do you have a voucher?</a>
    </div> -->


    <div class="cart-total">
      <div id="alertMsg" class="alert alert-primary" role="alert" *ngIf="membershipSuggestions !== null" (click)="closeSubscriptionMessage()">
        <a class="close pull-right">&times;</a>
        <div>
         {{'CART.SAVE_MORE_ITEN_MSG' | translate}}
          <span class="font-weight-bold">
            ₹{{membershipSuggestions?.orderAmount - total  | number : '1.2-2'}}
          </span>
          {{'CART.FOR_GETTING' | translate}}
           <span class="font-weight-bold">
            {{membershipSuggestions?.nameEng}}
           </span>
            {{'CART.MEMBERSHIP' | translate}}
        </div>
      </div>
      <p class="saving d-flex justify-content-between">
        <span>{{'CART.TOTAL_SAVINGS' | translate}}</span>
        <span>&#8377;{{saving | number : '1.2-2'}}</span>
      </p>
      <p class="total-price d-flex justify-content-between">
        <span>{{'CART.Total' | translate}}</span>
        <span>&#8377;{{total | number : '1.2-2'}}</span>
      </p>
      <a routerLink="/checkout" class="procced-checkout" onclick="cartclose()" *ngIf="cartList.length>0">{{'CART.PROCEED_TO_CHECKOUT' | translate}}</a>
    </div>
  </div>
